import React, {useMemo} from 'react';
import SaveCartInvoker from "../services/SaveCartInvoker";
import CatchErrors from "../../Utility/CatchErrors";
import SaveCartUi from "./SaveCartUi";

const isDev = (process.env.NODE_ENV == 'development');

/**
 * SaveCartContainer is rendered by SaveCartApp which is physically just above
 * the shopping cart in the page.  It provides logic for, and holds, both the
 * SaveCartInvoker (an invisible component) and the SaveCartModal (a modal
 * that exists only when needed).
 */
export default function SaveCartContainer({
  currentAgent,
  saveCartStatus,
  shoppingCart,
  dispatch,
  cartConfig,
  ...props
}) {
  const saveCartConfig = useMemo(() => cartConfig.saveCart || {} , [cartConfig]);

  if (saveCartConfig?.disabled)
    return null;

  return <div className="clear-me">
    {!currentAgent && <CatchErrors label="SaveCartInvoker"><SaveCartInvoker
      shoppingCart={shoppingCart}
      saveCartStatus={saveCartStatus}
    /></CatchErrors>}

    <CatchErrors label="SaveCartUI"><SaveCartUi
      saveCartStatus={saveCartStatus}
      shoppingCart={shoppingCart}
    /></CatchErrors>
  </div>
}

// usage:
// <SaveCartDebug saveCartStatus={saveCartStatus} />

function SaveCartDebug({
  saveCartStatus = {}
}) {
  if (!isDev) return false;

  return <div className="grid grid-cols-2">
    <div className="debug overflow-clip">
      <pre>{JSON.stringify(saveCartStatus, null, 2)}</pre>
    </div>
    <div className="debug overflow-clip">
    </div>
  </div>
}







